import { render, staticRenderFns } from "./ItsOrderDepartDetail.vue?vue&type=template&id=44845f97&scoped=true&"
import script from "./ItsOrderDepartDetail.vue?vue&type=script&lang=js&"
export * from "./ItsOrderDepartDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsOrderDepartDetail.vue?vue&type=style&index=0&id=44845f97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44845f97",
  null
  
)

export default component.exports